import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import InteracTransfer from "@/pages/InteracTransfer";
import Admin from "@/pages/Admin";
import Policies from "@/pages/Policies";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App bg-[#05080E] text-slate-200">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produits" element={<Products />} />
            <Route path="/produit/:id" element={<ProductDetail />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/temoignages" element={<Testimonials />} />
            <Route path="/commander" element={<Checkout />} />
            <Route path="/paiement/succes" element={<PaymentSuccess />} />
            <Route path="/paiement/interac" element={<InteracTransfer />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/politiques" element={<Policies />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors closeButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
